(function () {
  function initHeader(root) {
    if (!root || root.dataset.nmhInit === '1') return;
    root.dataset.nmhInit = '1';

    var h = root.querySelector('[data-nmh-h]');
    var m = root.querySelector('[data-nmh-m]');
    var st = root.querySelector('[data-nmh-st]');
    var su = root.querySelector('[data-nmh-su]');
    var prog = root.querySelector('[data-nmh-progress]');

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    function flip(el, val) {
      if (!el || el.textContent === val) return;
      el.textContent = val;
      el.classList.remove('nmtick');
      void el.offsetWidth;
      el.classList.add('nmtick');
    }

    function tickPromo() {
      var now = new Date();
      var end = new Date();
      end.setHours(23, 59, 59, 999);
      var d = end - now;
      var H = Math.max(0, Math.floor(d / 3600000) % 24);
      var M = Math.max(0, Math.floor(d / 60000) % 60);
      var S = Math.max(0, Math.floor(d / 1000) % 60);
      if (h) h.textContent = pad(H);
      if (m) m.textContent = pad(M);
      var ss = pad(S);
      if (st) st.textContent = ss.charAt(0);
      flip(su, ss.charAt(1));
      var passed = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
      if (prog) prog.style.width = (1 - passed / 86400) * 100 + '%';
    }

    tickPromo();
    setInterval(tickPromo, 1000);

    var lastScroll = 0;
    var ticking = false;
    var mqPhone = window.matchMedia('(max-width: 749.98px)');
    var mqDesktop = window.matchMedia('(min-width: 1025px)');

    function onScroll() {
      var y = window.scrollY || 0;
      /* Téléphone : header sticky toujours visible. Tablette/PC : hide au scroll down. */
      if (!mqPhone.matches) {
        if (y > 80 && y > lastScroll) {
          root.classList.add('nmh--scroll-down');
        } else {
          root.classList.remove('nmh--scroll-down');
        }
      } else {
        root.classList.remove('nmh--scroll-down');
      }
      if (y > 24) root.classList.add('nmh--scrolled');
      else root.classList.remove('nmh--scrolled');
      lastScroll = y;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(onScroll);
          ticking = true;
        }
      },
      { passive: true }
    );

    var burger = root.querySelector('[data-nmh-menu-toggle]');
    var navClose = root.querySelector('[data-nmh-nav-close]');

    function setBurgerExpanded(open) {
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function openNav() {
      root.classList.remove('nmh--scroll-down');
      document.body.classList.add('nmh-nav-open');
      setBurgerExpanded(true);
      /* Évite tout containing-block (sticky/transform) pendant le drawer */
      if (nav && nav.parentElement !== document.body) {
        nav.dataset.nmhHome = '1';
        document.body.appendChild(nav);
      }
    }

    function closeNav() {
      document.body.classList.remove('nmh-nav-open');
      setBurgerExpanded(false);
      root.querySelectorAll('.dropdown-menu.submenu-open').forEach(function (el) {
        el.classList.remove('submenu-open');
      });
      if (nav && nav.dataset.nmhHome === '1') {
        var slot = root.querySelector('.nmh__bar-inner');
        var actions = root.querySelector('.nmh__actions');
        if (slot && actions) slot.insertBefore(nav, actions);
        else if (slot) slot.appendChild(nav);
        delete nav.dataset.nmhHome;
      }
    }

    if (burger) {
      burger.addEventListener('click', function () {
        if (document.body.classList.contains('nmh-nav-open')) closeNav();
        else openNav();
      });
    }

    if (navClose) navClose.addEventListener('click', closeNav);

    var nav = root.querySelector('[data-nmh-nav]');
    if (nav) {
      nav.addEventListener('click', function (e) {
        if (e.target === nav) closeNav();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('nmh-nav-open')) {
        closeNav();
      }
    });

    root.querySelectorAll('[data-nmh-open-children]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var parent = btn.closest('.dropdown-menu');
        if (parent) parent.classList.add('submenu-open');
      });
    });

    root.querySelectorAll('[data-nmh-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parent = btn.closest('.dropdown-menu');
        if (parent) parent.classList.remove('submenu-open');
      });
    });

    root.querySelectorAll('[data-nmh-close-mobile]').forEach(function (btn) {
      btn.addEventListener('click', closeNav);
    });

    function clampSubmenu(item) {
      var submenu = item.querySelector('.submenu');
      if (!submenu) return;

      requestAnimationFrame(function () {
        var pad = 16;
        var vw = window.innerWidth;
        var parentRect = item.getBoundingClientRect();
        var subW = submenu.offsetWidth;
        var subH = submenu.offsetHeight;

        var idealLeft = parentRect.left + parentRect.width / 2 - subW / 2;
        var clampedLeft = Math.max(pad, Math.min(idealLeft, vw - pad - subW));
        var relativeLeft = clampedLeft - parentRect.left;

        var top = parentRect.bottom + 10;
        if (top + subH > window.innerHeight - pad) {
          top = Math.max(pad, window.innerHeight - pad - subH);
        }

        submenu.style.left = relativeLeft + 'px';
        submenu.style.top = top - parentRect.top + 'px';
        submenu.style.transform = 'translateY(0)';
      });
    }

    function resetSubmenu(item) {
      var submenu = item.querySelector('.submenu');
      if (!submenu) return;
      submenu.style.left = '';
      submenu.style.top = '';
      submenu.style.transform = '';
    }

    function bindDesktopDropdowns() {
      if (!mqDesktop.matches) return;
      root.querySelectorAll('.dropdown-menu').forEach(function (item) {
        if (item.dataset.nmhDesktopBound === '1') return;
        item.dataset.nmhDesktopBound = '1';
        var trigger = item.querySelector('.nmh-menu-link--has-submenu');
        item.addEventListener('mouseenter', function () {
          if (!mqDesktop.matches) return;
          item.classList.add('visible');
          if (trigger) trigger.setAttribute('aria-expanded', 'true');
          clampSubmenu(item);
        });
        item.addEventListener('mouseleave', function () {
          if (!mqDesktop.matches) return;
          item.classList.remove('visible');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          resetSubmenu(item);
        });
      });
    }

    bindDesktopDropdowns();

    window.addEventListener('resize', function () {
      if (mqDesktop.matches) {
        closeNav();
        root.querySelectorAll('.dropdown-menu.visible').forEach(clampSubmenu);
        bindDesktopDropdowns();
      } else {
        root.querySelectorAll('.dropdown-menu.visible').forEach(function (item) {
          item.classList.remove('visible');
          resetSubmenu(item);
        });
      }
    });
  }

  document.querySelectorAll('[data-nmh]').forEach(initHeader);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-nmh]');
    if (root) {
      root.dataset.nmhInit = '';
      initHeader(root);
    }
  });
})();
